"use client"
import { useEffect, useState } from "react";
import useHash from "@packages/hooks/DetectHashChange";
import { ClickstreamInterface } from "@packages/lib/utlils/clickstream";
import PageViewLogging from "@packages/lib/utlils/pageviewlogging";
import { ClickstreamConstants, GAConstants } from "../services/constants";

interface InstitutionProfileFragmentWrapperProps {
  fragmentId: string;
  defaultFragmentId: string;
  children: React.ReactNode;
  commonGAAttrs: any;
  gaPageName: string;
  CSCommonData: any;
  fragmentName: string;
  commonOldGAAttrs ?: any
}

const InstitutionProfileFragmentWrapper = ({
  fragmentId,
  defaultFragmentId,
  children,
  commonGAAttrs,
  gaPageName,
  CSCommonData,
  fragmentName,
  commonOldGAAttrs
}: InstitutionProfileFragmentWrapperProps) => {
  const [hash] = useHash();
  const currentFragment = hash || defaultFragmentId;
  const isActive = fragmentId === currentFragment;

  const [shouldLog, setShouldLog] = useState(false);
  const [hasMounted, setHasMounted] = useState(false);

  // Clear session flag on component mount (page refresh)
  useEffect(() => {
    if (typeof window !== "undefined") {
      sessionStorage.removeItem("lastLoggedUrl");
      setHasMounted(true);
    }
  }, []);

  useEffect(() => {
    if (typeof window === "undefined" || !isActive || !hasMounted) return;

    const baseUrl = window.location.pathname + window.location.search;
    const lastLoggedUrl = sessionStorage.getItem("lastLoggedUrl");
    const isSkipLink = sessionStorage.getItem("activeSkipLink") === "Y";

    // Don't log if skip link navigation
    if (isSkipLink) return;

    // Only log on page load/refresh or URL change
    if (!lastLoggedUrl || lastLoggedUrl !== baseUrl) {
      setShouldLog(true);
      sessionStorage.setItem("lastLoggedUrl", baseUrl);
    }
  }, [isActive, hasMounted]);

  // Reset shouldLog after logging
  useEffect(() => {
    if (shouldLog) {
      const timer = setTimeout(() => setShouldLog(false), 0);
      return () => clearTimeout(timer);
    }
  }, [shouldLog]);

  const CSData = (): ClickstreamInterface => ({
    ...CSCommonData,
    eventType: "InstitutionProfileViewed",
    actionType: ClickstreamConstants.pageViewAction,
    sectionName: fragmentName,
  });

  return (
    <>
      {isActive && shouldLog && (
        <PageViewLogging
          pageNameLocal={gaPageName || "institution_profile"}
          gaData={{
            ...commonGAAttrs,
          page_section: fragmentName,
          page_grouping:GAConstants.pageGrouping.insitution_related
          }}
          csData={{...CSData(), functionalityName: "Insitution Profile",}}
          gaoldData={{...commonOldGAAttrs,data_label:fragmentName}}
        />
      )}
      <div
        className={`${
          isActive ? "block animate-fadeIn" : "hidden animate-fadeOut"
        } transition-all duration-300 ease-in-out`}
      >
        {children}
      </div>
    </>
  );
};

export default InstitutionProfileFragmentWrapper;
